// SalesShark — Hungarian (source language)
const hu = {
    code: "hu",
    label: "Magyar",
    short: "HU",
    flag: "🇭🇺",
    htmlLang: "hu",
    nav: {
        home: "Főoldal",
        services: "Szolgáltatásaink",
        about: "Rólunk",
        references: "Referenciák",
        contact: "Kapcsolat",
        faq: "FAQ",
        consultation: "Ingyenes konzultáció",
    },
    hero: {
        eyebrow: "International Sales Agency",
        headingA: "Minden perc, amikor nem minket választ,",
        headingB: "a versenytársainak kedvez.",
        subheading:
            "Kiszámítható, mérhető sales pipeline a célpiac kiválasztásától a szerződéskötésig — saját cégadatbázisunkra, célzott e-mail kampányokra és többnyelvű telefonos megkeresésre építve.",
        ctaPrimary: "Ingyenes konzultáció",
        ctaSecondary: "Szolgáltatásaink",
        marketsLabel: "Aktív piacaink",
        markets: [
            { code: "HU", name: "Magyarország" },
            { code: "SK", name: "Szlovákia" },
            { code: "CZ", name: "Csehország" },
            { code: "AT", name: "Ausztria" },
        ],
    },
    quickServices: {
        eyebrow: "Amit kínálunk",
        heading: "Kilenc terület, egy egységes sales gépezet.",
        subheading:
            "A cégadatbázistól a szerződéskötésig — végig egy csapattal.",
        items: [
            "Cégadatbázis országonként",
            "Időpontszervezés",
            "Hideghívás",
            "Telemarketing",
            "Munkatárs biztosítása",
            "Terjeszkedés",
            "Branding",
            "Marketing",
            "Social Media",
        ],
    },
    results: {
        eyebrow: "SalesShark",
        heading: "Az eredmény számít.",
        bullets: [
            "A SalesShark egy eredményorientált ügyfélszerzési csapat: kiszámítható, mérhető pipeline-t építünk a célpiac kiválasztásától a szerződéskötésig.",
            "Erős értékünk: a saját, országonként strukturált cégadatbázisunk (HU / SK / CZ / AT), amire célzott e-mail kampányokat és telefonos megkeresést építünk a minősített meetingekért és dedikált SALES munkatársat biztosítunk a szerződéskötésekért.",
            "Nyelvek: magyar, szlovák, cseh, angol, német.",
            "Hiszünk az emberi kapcsolatok erejében: a bizalom, a korrekt kommunikáció és a következetes utánkövetés szerintünk mindig erősebb, mint bármilyen „trükk”.",
        ],
        ctaPrimary: "Ingyenes konzultáció",
        ctaSecondary: "Kapcsolat",
    },
    detailedServices: {
        eyebrow: "Szolgáltatásaink",
        heading: "Egy világos folyamat, hét bevétel-hozó modul.",
        subheading:
            "A cégadatbázistól a havi riportig — minden modul egy egységes sales gépezet része.",
        ctaMore: "Bővebben",
        items: [
            { title: "Cégadatbázis HU / SK / CZ / AT", text: "Céglista szűrőkkel és elérhetőségekkel." },
            { title: "E-mail marketing", text: "Tömeges e-mail küldése + időpontfoglalási CTA + riport." },
            { title: "Telefonos megkeresések", text: "Hideghívások, telemarketing HU/SK/CZ/EN/DE nyelveken." },
            { title: "Munkatárs biztosítása", text: "Rövid és hosszútávú értékesítési erőforrás igény szerint HU/SK/CZ/EN/DE nyelveken rendszerünk használatával + meglévő ügyfélgondozás." },
            { title: "Marketing + PPC", text: "Branding, videók, kreatívok, arculat, promó anyagok, névjegykártya, social media kampánytervezés és futtatás stb." },
            { title: "Terjeszkedés támogatása (HU/SK/CZ/AT)", text: "Piackutatás, cégalapítás, bankszámla, egyéb ügyintézés." },
            { title: "Havi riport készítése", text: "Státuszok, KPI-k, következő lépések, rendszeres összefoglaló." },
        ],
    },
    problems: {
        eyebrow: "Melyik igaz Önre?",
        heading: "Mondja el nekünk!",
        subheading:
            "Ha a lenti helyzetek közül akár csak egy is ismerős, valószínűleg dolgozhatunk együtt.",
        cta: "Ingyenes konzultáció",
        items: [
            "Jó a termékem/szolgáltatásom, de több ügyfelet szeretnék.",
            "Terjeszkedni szeretnék egy másik országban.",
            "Kell egy profi marketinges.",
            "Nem látok rá a fizetett kollégám munkájára: hány céget hívtunk fel?",
            "Új munkatársra lenne szükségem.",
            "Döntéshozókat szeretnék elérni, nem általános kontaktokat.",
            "Nincs időm napi szinten keresgélni és hívogatni.",
            "Megoldásokat akarok, nem mellébeszédet.",
            "Keveset foglalkozom a meglévő ügyfeleimmel.",
        ],
    },
    references: {
        eyebrow: "Referenciák",
        headingA: "Partnereink sikerei",
        headingB: "a mi legfontosabb referenciánk.",
        statBadge: "50+ partner · 4 piac · 5 nyelv",
        verifiedBadge: "Verifikált",
        items: [
            { company: "WHC SLOVAKIA", role: "CEO", text: "Kiemelten értékeljük a csapat hozzáállását, pontosságát és azt, hogy valódi üzleti eredményekben gondolkodnak. A SalesShark olyan partner, akire egy növekedésorientált vállalat bátran rábízhatja az értékesítési folyamatainak egy részét vagy egészét." },
            { company: "iNTRETECH", role: "CEO", text: "Antallal és Antóniával való együttműködés során egy olyan partnerre találtunk, amely valódi értéket teremt az értékesítési folyamatainkban. A megkeresések minősége, a riportálás átláthatósága és a csapat szakmai felkészültsége megerősítette bennünk, hogy az adatvezérelt sales ma már elengedhetetlen." },
            { company: "MOTIM ZRT.", role: "CEO", text: "A SalesShark csapatával gyorsan világossá vált, hogy nem egyszerű szolgáltatót választottunk, hanem valódi stratégiai partnert. A rendszerük átlátható, a kommunikációjuk professzionális, és minden tevékenységük mérhető. A SalesShark konkrét, számonkérhető eredményeket szállít – ezért dolgozunk velük." },
        ],
    },
    goal: {
        eyebrow: "Célunk",
        heading: "Eredményeket hozni — a jobb ügyfélgondozástól az új piacokig.",
        p1: "Eredményeket hozni, a jobb ügyfélgondozástól kezdve az értékesítés növelésén át egészen az új piacok megnyitásáig.",
        p2: "Velünk megbízható partnert szerez, aki lépésről lépésre támogatja vállalkozása fejlődését.",
        ctaContact: "Kapcsolat",
        ctaPresentation: "Cégbemutató prezentáció",
    },
    about: {
        eyebrow: "Rólunk",
        headingA: "Adatokkal dolgozunk,",
        headingB: "eredményben mérünk,",
        headingC: "emberi kapcsolatokban hiszünk.",
        story: {
            eyebrow: "A történetünk",
            p1: "2023-ban, Pozsonyban alapítottuk meg a GLOBEFOX Nemzetközi Munkaerő-ügynökséget — innen indult a nemzetközi sales fókusz, amely ma a SalesShark alapja.",
            p2: "Ma már Magyarországon, Szlovákiában és Csehországban is toborozzunk, és több mint 50 partnerrel dolgozunk együtt, köztük gyáróriásokkal és piacvezető cégekkel. A munkaerő-közvetítés mellett cégalapítással és könyveléssel is segítjük ügyfeleinket.",
            p3: "Nemzetközi tapasztalatunk és többnyelvű csapatunk lehetővé teszi, hogy ügyfeleinket határokon átívelően, professzionális szinten képviseljük.",
        },
        stats: [
            { n: "2023", label: "Alapítva Pozsonyban" },
            { n: "50+", label: "Aktív partner" },
            { n: "4", label: "Piac · HU / SK / CZ / AT" },
            { n: "5", label: "Nyelv · HU / SK / CZ / EN / DE" },
        ],
        pillars: {
            eyebrow: "Miértünk",
            headingA: "Négy alapelv, egy vezérfonal:",
            headingB: "eredmény.",
            items: [
                { title: "Adatvezérelt sales", text: "Saját, országonként strukturált cégadatbázisunkból építünk mérhető pipeline-t — nem sejtésből dolgozunk." },
                { title: "Mérhető eredmények", text: "Heti státusz, KPI-k, riportok — mindig tudja, hol tart a folyamat és mi a következő lépés." },
                { title: "Emberi kapcsolatok", text: "A bizalom, a korrekt kommunikáció és a következetes utánkövetés erősebb, mint bármilyen trükk." },
                { title: "Többnyelvű működés", text: "Magyar, szlovák, cseh, angol és német nyelven képviseljük ügyfeleinket, határokon átívelően." },
            ],
        },
        team: {
            eyebrow: "A csapat",
            heading: "Az arcok a folyamatok mögött.",
            members: [
                {
                    role: "Ügyvezető / CEO · International Lawyer",
                    bio: [
                        "2023-ban, Pozsonyban alapítottuk meg a GLOBEFOX Nemzetközi Munkaerő-ügynökséget. Én nemzetközi jogászként csatlakoztam a munkához, és négy nyelven beszélek.",
                        "Ez tette lehetővé, hogy a GLOBEFOX kezdettől nemzetközi irányba induljon, és ma már Magyarországon, Szlovákiában és Csehországban is toborozzunk. Mára már több mint 50 partnerrel dolgozunk együtt, köztük gyáróriásokkal és piacvezető cégekkel.",
                        "Nemzetközi tapasztalatunk és többnyelvű csapatunk lehetővé teszi, hogy ügyfeleinket határokon átívelően, professzionális szinten képviseljük.",
                    ],
                },
                {
                    role: "COO / Operatív vezető · Alapító",
                    bio: [
                        "Stratégiáért és az értékesítési rendszerek felépítéséért felelek: célom, hogy minden ügyfelünk olyan sales-megoldást kapjon, amely valódi növekedést és stabil ügyfélszerzést biztosít.",
                        "Napi szinten foglalkozom kampányok tervezésével, adatalapú optimalizálással és azokkal a folyamatokkal, amelyek biztosítják, hogy ügyfeleink több érdeklődőt, időpontot és új ügyfelet érjenek el.",
                        "Célunk, hogy a SalesShark a régió legerősebb, legmegbízhatóbb sales-ügynöksége legyen — valódi eredményekkel, nem ígéretekkel.",
                    ],
                },
            ],
        },
    },
    contact: {
        eyebrow: "Kapcsolat",
        headingA: "Kérdése van?",
        headingB: "24 órán belül válaszolunk.",
        ctaConsultation: "Ingyenes konzultáció",
        officeTitle: "Irodáink",
        officeSubtitle: "Négy irodával a régióban",
        offices: [
            { country: "HU", city: "2900 Komárom" },
            { country: "SK", city: "811 01 Bratislava" },
            { country: "HU", city: "9200 Mosonmagyaróvár" },
            { country: "SK", city: "943 01 Dunaszerdahely" },
        ],
        company: {
            name: "GLOBEFOX s.r.o.",
            addressLine1: "Sabinovska 9., Bratislava",
            addressLine2: "831 04, Slovakia",
            id: "Company ID: 55 100 376",
        },
    },
    form: {
        eyebrow: "Írjon nekünk",
        heading: "Hagyjon üzenetet — 24 órán belül válaszolunk.",
        labels: {
            name: "Név",
            email: "E-mail",
            phone: "Telefonszám",
            company: "Cégnév",
            message: "Üzenet",
        },
        placeholders: {
            name: "Kovács János",
            email: "janos@ceg.hu",
            phone: "+36 30 123 4567",
            company: "Acme Kft.",
            message: "Miben segíthetünk?",
        },
        companyHelper: "Opcionális — magánszemélyként hagyja üresen.",
        disclaimer:
            "A beküldéssel elfogadja, hogy megkeressük Önt a megadott elérhetőségeken.",
        submit: "Üzenet küldése",
        sending: "Küldés…",
        successTitle: "Üzenetét megkaptuk.",
        successText: "24 órán belül válaszolunk a megadott e-mail címre.",
        errorTitle: "Sajnos nem sikerült elküldeni.",
        errorText: "Kérjük próbálja újra, vagy írjon közvetlenül nekünk.",
    },
    faq: {
        eyebrow: "FAQ",
        headingA: "Gyakori kérdések.",
        headingB: "Rövid, egyenes válaszok.",
        items: [
            { q: "Milyen országokban dolgoznak?", a: "Magyarországon, Szlovákiában, Csehországban és Ausztriában vagyunk aktívak. Saját, országonként strukturált cégadatbázisunkkal és többnyelvű csapatunkkal (magyar, szlovák, cseh, angol, német) segítjük partnereink piacra lépését és növekedését." },
            { q: "Mekkora a cégadatbázisuk?", a: "Magyarország: 16 000 cég, Szlovákia: 13 000 cég, Ausztria: 47 000 cég, Csehország: 3 000 cég. Az adatbázist folyamatosan frissítjük, és iparág, cégméret, telephelyszám és régió szerint szűrhető." },
            { q: "Milyen nyelveken végzik a telefonos megkeresést?", a: "A hívásokat és az utánkövetést magyar, szlovák, cseh, angol és német nyelven is vállaljuk." },
            { q: "Az e-mail kampányok az Önök nevéből futnak?", a: "Nem. Az e-mail sorozatokat az Ön vállalati e-mail címéről küldjük ki, így Ön is közvetlenül nyomon tudja követni a kiküldéseket, a válaszokat és az egyeztetések alakulását." },
            { q: "Mit tartalmaz a havi riport?", a: "Státuszokat, KPI-kat, következő lépéseket és rendszeres összefoglalót — hogy mindig lássa, hol tart a pipeline." },
            { q: "Hogyan kezdhetjük el a közös munkát?", a: "Foglaljon egy 15 perces ingyenes konzultációt a naptárban. Feltérképezzük a célpiacot, a jelenlegi helyzetét és javaslatot teszünk a legjobb belépési stratégiára." },
        ],
        notFoundEyebrow: "Nem találja a választ?",
        notFoundHeading: "Kérdezzen tőlünk közvetlenül.",
        ctaConsultation: "Ingyenes konzultáció",
        ctaContact: "Kapcsolat",
    },
    footer: {
        eyebrow: "Kezdje el még ma",
        heading: "Beszéljünk a következő piacáról.",
        subheading:
            "15 perces ingyenes konzultáció — mérhető sales pipeline HU / SK / CZ / AT piacokon.",
        cta: "Ingyenes konzultáció",
        tagline:
            "International Sales Agency. Eredményorientált ügyfélszerzés, saját cégadatbázis és dedikált sales munkatárs HU / SK / CZ / AT piacokon.",
        contactHeading: "Kapcsolat",
        menuHeading: "Menü",
        copyright: (year) =>
            `© ${year} SalesShark · GLOBEFOX s.r.o. Minden jog fenntartva.`,
        roles: {
            antonia: "Somogyi Antónia · CEO",
            antal: "Korcz Antal · COO",
        },
    },
    services: {
        hero: {
            eyebrow: "Szolgáltatásaink",
            headingA: "Digitális és emberi értékesítés összehangolva,",
            headingB: "eredményre optimalizálva.",
            subheading:
                "Hat modul, egy egységes folyamat — a piackutatástól a személyes képviseletig.",
        },
        sideNavTitle: "Szolgáltatások",
        eyebrows: {
            dataDriven: "Adatvezérelt értékesítés",
            process: "Folyamat",
            service: "Szolgáltatás",
        },
        ctaConsultation: "Ingyenes konzultáció",
        ctaContact: "Kapcsolat",
        bottomCta: {
            eyebrow: "Készen áll a következő lépésre?",
            heading: "Egy 15 perces beszélgetés a következő piacáról.",
            subheading:
                "Mutassuk meg, hogyan építünk mérhető pipeline-t a saját cégadatbázisunkkal HU / SK / CZ / AT piacokon.",
        },
        sections: {
            cegadatbazis: {
                label: "Cégadatbázis",
                title: "Cégadatbázis",
                intro: [
                    "A cégekről rövid információt, webhelyelérhetőségeket is tartalmaz.",
                    "Ha eddig Google-ben kereste a potenciális célpartnereket, ezzel jelentősen felgyorsítható a piackutatás és a megkeresés.",
                    "Név szerinti elérhetőségeket tartalmazó adatbázisunkat folyamatosan frissítjük.",
                ],
                statLabel: "cég",
                stats: [
                    { country: "Magyarország", value: "16 000" },
                    { country: "Szlovákia", value: "13 000" },
                    { country: "Ausztria", value: "47 000" },
                    { country: "Csehország", value: "3 000" },
                ],
                filtersTitle: "A következő szűrők állnak rendelkezésünkre:",
                filters: ["Iparág", "Cégméret (employee count)", "Telephelyszám", "Régió"],
            },
            email: {
                label: "E-mail marketing",
                title: "E-mail marketing",
                steps: [
                    { title: "Célcsoport kiválasztása a cégadatbázisból", text: "Szűrés iparág, régió, cégméret." },
                    { title: "Tömeges e-mail sorozatok", text: "Hírlevél, bemutatkozó, ajánlati üzenetek, ütemezett utánkövetéssel, leiratkozási lehetőséggel." },
                    { title: "Beépített időpontfoglalás (CTA)", text: "A címzett 1 kattintással 15 perces egyeztetést foglal, a rendszer automatikusan rögzíti az eseményt és a naptárba teszi." },
                    { title: "Valós idejű tracking és riport", text: "Kézbesítés, megnyitás, kattintás, válasz, időpontfoglalás — kampányonként és címzettenként is visszamérhető." },
                    { title: "Az Ön céges e-mail címéről", text: "Az e-mail sorozatokat az Ön vállalati e-mail címéről küldjük ki, így Ön is közvetlenül nyomon tudja követni a kiküldéseket, a válaszokat és az egyeztetések alakulását." },
                ],
            },
            phone: {
                label: "Telefonos megkeresés",
                title: "Telefonos megkeresés",
                items: [
                    { title: "Hideg hívások", text: "Adatbázisból keressük a cégeket, felépített beszélgetési vázlattal." },
                    { title: "Felmelegített hívások", text: "Azokat is hívjuk, akik az e-mail kampányban aktivitást mutattak." },
                    { title: "Időpont szervezés", text: "Célunk elérni a döntéshozót, időpontot szervezni az értékesítőnek." },
                    { title: "Telemarketing", text: "Betanulás és telefonos értékesítés + riport." },
                    { title: "Többnyelvű megkeresés", text: "A hívásokat és az utánkövetést magyar, szlovák, cseh, angol és német nyelven is vállaljuk." },
                    { title: "Átadás és dokumentálás", text: "Kivel mi volt, mi hangzott el, mi az igény, mi a következő lépés, egyeztetett időpont, vagy elutasítás." },
                ],
            },
            staff: {
                label: "Munkatárs biztosítása",
                title: "Munkatárs biztosítása",
                items: [
                    { title: "Sales, telefonos értékesítő, ügyintéző vagy koordinátor munkaerő biztosítása", text: "Önéletrajzokból választható alkalmi vagy hosszútávú partner, aki a megbízó cég „arca” és az Ön cége nevében kommunikál HU / SK / CZ / EN / DE nyelveken." },
                    { title: "Rendszer", text: "A munkatárs a mi workflow-unkat használja (státuszok, utánkövetés, meeting brief, riportok)." },
                    { title: "Teljes eszközbiztosítás igény esetén", text: "Céges autó, telefon és laptop biztosítása, hogy a munkavégzés azonnal, professzionális szinten indulhasson." },
                    { title: "Onboarding és betanítás", text: "Felkészítés a termékre, célpiacra." },
                    { title: "Szakmai felügyelet", text: "Vezetés és minőségellenőrzés, heti státusz/riport készítése + pipeline, hogy mindig lássuk, hol tartunk." },
                ],
            },
            marketing: {
                label: "Marketing",
                title: "Marketing",
                items: [
                    { title: "Branding", text: "Arculat és logo tervezés." },
                    { title: "Kreatív gyártás", text: "Professzionális képek, videók, grafikai anyagok, animációk, több nyelven is." },
                    { title: "Sales anyagok", text: "Prezentációk, ajánlati anyagok, one-pager, névjegykártya, promóciós anyagok." },
                    { title: "Online hirdetések (PPC)", text: "Kampánytervezés, beállítás, folyamatos optimalizálás (FB/IG/Google)." },
                    { title: "Közösségi média tartalom és kampányok", text: "Posztok, hirdetések." },
                    { title: "Mérés és riportálás", text: "KPI-k követése, tanulságok, finomhangolás és skálázás." },
                ],
            },
            expansion: {
                label: "Terjeszkedés",
                title: "Terjeszkedne? Segítünk!",
                steps: [
                    { title: "Piackutatás és célpiac-kijelölés", text: "Országonkénti fókusz (iparág, cégméret, régió, versenykörnyezet)." },
                    { title: "Belépési stratégia és ütemezés", text: "Kinek adunk el, milyen ajánlattal, mely csatornákon, milyen lépésekben." },
                    { title: "Célzott céglista és döntéshozói elérhetőségek", text: "Az adott országban, saját adatbázisunkra építve (HU / SK / CZ / AT)." },
                    { title: "Piacnyitó outreach kampányok", text: "Szegmentált bemutatkozó e-mailek + több lépéses utánkövetés." },
                    { title: "Többnyelvű telefonos megkeresés és időpontszervezés", text: "HU / SK / CZ / EN / DE nyelveken, minősített meetingekkel." },
                    { title: "Személyes képviselet", text: "Alkalmi projektek és hosszútávú projektek egyaránt." },
                    { title: "Riportálás és optimalizálás", text: "Eredmények mérése, finomhangolás, skálázás a legjobban működő szegmensekre." },
                    { title: "Opcionális: Cégalapítás, fordítás, bankszámlanyitás, egyéb ügyintézés", text: "Gyakorlati segítség az induláshoz és működéshez." },
                ],
            },
        },
    },
    languageSwitcher: {
        label: "Nyelv",
        aria: "Nyelv választása",
    },
};

export default hu;
